import React from 'react';
import PropTypes from 'prop-types';

import StyledMessageWithTrigger from './StyledMessageWithTrigger';

const MessageWithTrigger = ({message = null, renderTrigger = null, separator = '{button}'}) => {
	if (!message)
		return (
			<StyledMessageWithTrigger body2 regular>
				{renderTrigger()}
			</StyledMessageWithTrigger>
		);

	const messageParts = message?.split(separator);

	return (
		<StyledMessageWithTrigger body2 light>
			{messageParts[0]}
			{renderTrigger()}
			{messageParts[1]}
		</StyledMessageWithTrigger>
	);
};

MessageWithTrigger.propTypes = {
	message: PropTypes.string,
	renderTrigger: PropTypes.func,
	separator: PropTypes.string
};

export default MessageWithTrigger;
